import { RefObject } from "react";

const SET_TYPE: string = 'input/SET_TYPE' as const;
const SET_REF : string = 'input/SET_REF' as const;

type setTypeAction = {
    type: typeof SET_TYPE;
    payload: string;
};

type ActionType = setTypeAction;

export const setInputType = (type: string) => ({type : SET_TYPE, payload: type});
export const setInputRef = (ref: RefObject<HTMLInputElement>) => ({type: SET_REF, payload: ref})

interface InitialStateType {
    type: string,
    inputRef?: RefObject<HTMLInputElement> | null
};

const initialState: InitialStateType = {
    type: 'textInput',
    inputRef: undefined,
};

export default function loading(state: InitialStateType = initialState, action: ActionType) {
    switch(action.type) {
        case SET_TYPE:
            return {
                ...state,
                type: action.payload,
            };
        case SET_REF:
            return {
                ...state,
                inputRef: action.payload,
            }
        default:
            return state;
    }
};